import { Component, OnInit, ViewChild, ChangeDetectorRef, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { interval, Observable, of, shareReplay, Subscription, take } from 'rxjs';
import { MoovInstanceAbstract } from '../../models/moovInstanceAbstract';
import { AccountService } from '../../services/AccountService';
import { AuthenticationService } from '../../services/AuthenticationService';
import { MoovService } from '../../services/MoovService';

@Component({ standalone:false,
    selector: 'app-moovs-in-process-table',
    templateUrl: './moovs-in-process-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./moovs-in-process-table.component.scss']
  })
  export class MoovsInProcessTableComponent implements OnInit {
    readonly customerContext = input<number|undefined>(undefined);
    readonly moovInstanceAbstractSelected = output<any>();

    paginator?: MatPaginator;
    sort?: MatSort;

    @ViewChild(MatSort) set matSort(ms: MatSort) {
      this.sort = ms;
      this.setDataSourceAttributes();
    }
      
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
      this.paginator = mp;
      this.setDataSourceAttributes();
    }
      
    setDataSourceAttributes() {
      if(this._dataSource){
        this._dataSource.paginator = this.paginator;
        this._dataSource.sort = this.sort;
      }
    }
  
    private _dataSource?: MatTableDataSource<MoovInstanceAbstract>;
  
    public busy:boolean=true;
  
    public pageSize: number = 50;

    private timerSubscription?:Subscription;

    constructor(private moovService:MoovService, private accService:AccountService, private authService:AuthenticationService, private cd:ChangeDetectorRef){
    }
 
    ngOnInit(){
      const storedPageSize = localStorage.getItem("MoovsInProcessTableComponentPageSize");
      const pageSize = storedPageSize ? parseInt(storedPageSize, 10) : NaN;
if (!isNaN(pageSize)) this.pageSize = pageSize;
      this.moovService.getProcessingMoovInstances(false).pipe(take(1)).subscribe(miaArray=>{
        this.processReceivedProcessingMoovInstances(miaArray);
      });
      this.startUpdateTimer();
    }

    ngOnDestroy(){
      localStorage.setItem("MoovsInProcessTableComponentPageSize", this.pageSize.toString());
      if(this.timerSubscription) this.timerSubscription.unsubscribe();
    }

    get displayedColumns(){
      if(this.isSuperAdmin){
        return ['customer', 'sourceFileName', 'moovDefinitionName', 'added'];
      }
      else{
        return ['sourceFileName', 'moovDefinitionName', 'added'];
      }
    }

    get dataSource(){
      return this._dataSource
    }

    get isSuperAdmin(){
      return !this.authService.customerContext && this.authService.isSuperAdmin;
    }

    private _customerCache = new Map<number, Observable<any>>();
    public getCustomer(customerId:number){
      let o = this._customerCache.get(customerId);
      if(!o){ o = this.accService.getCustomerById(customerId).pipe(shareReplay({bufferSize:1, refCount:false})); this._customerCache.set(customerId, o); }
      return o;
    }

    private processReceivedProcessingMoovInstances(miaArray: MoovInstanceAbstract[]){
      this.busy=false;
      this._dataSource=new MatTableDataSource(miaArray);
      this._dataSource.paginator = this.paginator;
      this._dataSource.sort = this.sort;
      this.cd.detectChanges();
    }

    public selectionChanged(mia:MoovInstanceAbstract){
      if(this.authService.customerContext){
        this.moovInstanceAbstractSelected.emit(mia);
      }
    }

    pageChanged(event:any){
      this.pageSize=event.pageSize;
    }
    onUpdateClick(){
      this.busy=true;
      this.updateMoovInstancesProcessing();
    }

    private startUpdateTimer(){
      this.timerSubscription = interval(60000).subscribe(x=>{
        this.busy=true;
        this.cd.detectChanges();
        this.updateMoovInstancesProcessing();
      })
    }
  
    private updateMoovInstancesProcessing(){
      this.moovService.getProcessingMoovInstances(true).pipe(take(1)).subscribe((miaArray:MoovInstanceAbstract[]) => {
        this.processReceivedProcessingMoovInstances(miaArray);
      });
    }
  }